document.addEventListener('DOMContentLoaded', function() {
  // --- MULTI-STEP FORM FUNCTIONALITY ---
  // Get all step items
  const steps = document.querySelectorAll('.multi-step_item');
  const progressItems = document.querySelectorAll('.progress-item');
  const progressBars = document.querySelectorAll('.progress-bar');
  const prevButton = document.querySelector('.multistep-prev');
  const nextButton = document.querySelector('.multistep-next');
  
  let currentStep = 0;
  const totalSteps = steps.length;
  
  // Initialize the form
  updateFormState();
  
  // Add event listeners to navigation buttons
  prevButton.addEventListener('click', goToPrevStep);
  nextButton.addEventListener('click', goToNextStep);
  
  // Function to go to the previous step
  function goToPrevStep() {
    if (currentStep > 0) {
      currentStep--;
      updateFormState();
      validateCurrentStepFields(); // Check if next button should be enabled
    }
  }
  
  // Function to go to the next step
  function goToNextStep() {
    if (validateCurrentStep()) {
      if (currentStep < totalSteps - 1) {
        currentStep++;
        updateFormState();
        validateCurrentStepFields(); // Check if next button should be enabled for the new step
      }
    }
  }
  
  // Function to validate the current step
  function validateCurrentStep() {
    // Perform validation logic for each step
    switch(currentStep) {
      case 0: // Upload step
        const uploadcareWidget = uploadcare.Widget('[role=uploadcare-uploader]');
        return uploadcareWidget.value() !== null;
        
      case 1: // Folie step
        return document.querySelector('input[name="contact[folie]"]:checked') !== null;
        
      case 2: // Farbe step
        const anzahlFarben = document.querySelector('input[name="contact[anzahl-farben]"]:checked');
        if (!anzahlFarben) return false;
        
        // Check if all color dropdowns that are visible have selections
        const numColors = anzahlFarben.value.charAt(0);
        for (let i = 0; i < numColors; i++) {
          const colorName = i === 0 ? 'Motivfarbe' : `Motivfarbe-${i+1}`;
          const colorDropdown = document.querySelector(`.select_item-motivcolor:nth-child(${i+1})`);
          if (colorDropdown && getComputedStyle(colorDropdown).display !== 'none') {
            const colorSelected = document.querySelector(`input[name="contact[${colorName}]"]:checked`);
            if (!colorSelected) return false;
          }
        }
        return true;
        
      case 3: // Angaben step
        const requiredFields = steps[3].querySelectorAll('input[required]');
        return Array.from(requiredFields).every(field => field.value.trim() !== '');
        
      case 4: // Infos step (final step)
        const widthField = document.querySelector('input[name="contact[Breite]"]');
        return widthField && widthField.value.trim() !== '';
        
      default:
        return true;
    }
  }
  
  // Function to validate current step fields and update next button state
  function validateCurrentStepFields() {
    const isValid = validateCurrentStep();
    if (isValid) {
      nextButton.classList.remove('disabled');
      nextButton.disabled = false;
    } else {
      nextButton.classList.add('disabled');
      nextButton.disabled = true;
    }
  }
  
  // Function to update the form state
  function updateFormState() {
    // Update steps visibility
    steps.forEach((step, index) => {
      if (index === currentStep) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });
    
    // Update progress items and bars
    progressItems.forEach((item, index) => {
      if (index <= currentStep) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    
    progressBars.forEach((bar, index) => {
      if (index < currentStep) {
        bar.style.background = 'var(--button-bg-color, #635bff)';
      } else {
        bar.style.background = '#ededed';
      }
    });
    
    // Update previous button state
    if (currentStep === 0) {
      prevButton.classList.add('disabled');
      prevButton.disabled = true;
    } else {
      prevButton.classList.remove('disabled');
      prevButton.disabled = false;
    }
    
    // Update next button visibility
    if (currentStep === totalSteps - 1) {
      nextButton.style.display = 'none';
    } else {
      nextButton.style.display = 'block';
    }
    
    // Show form submit button only on the last step
    const submitButton = document.querySelector('button[type="submit"]');
    if (submitButton) {
      if (currentStep === totalSteps - 1) {
        submitButton.style.display = 'block';
      } else {
        submitButton.style.display = 'none';
      }
    }
    
    // Validate the current step fields to update next button state
    validateCurrentStepFields();
  }
  
  // --- COLOR DROPDOWN FUNCTIONALITY ---
  // Initialize color dropdowns control
  initColorDropdownsControl();
  
  // Initialize color picker functionality
  initColorPicker();
  
  // Add validation listeners after initializing color pickers
  addValidationListeners();
  
  // Color Dropdowns Control Function
  function initColorDropdownsControl() {
    // Get references to all radio buttons for the number of colors
    const colorRadios = document.querySelectorAll('input[name="contact[anzahl-farben]"]');
    
    // Get references to all color dropdowns
    const colorDropdowns = document.querySelectorAll('.select_item-motivcolor');
    
    // Set default selection if none is selected
    if (!document.querySelector('input[name="contact[anzahl-farben]"]:checked')) {
      if (colorRadios.length > 0) colorRadios[0].checked = true;
    }
    
    // Function to update the visibility of color dropdowns
    function updateColorDropdowns() {
      // Get the selected radio button
      const selectedRadio = document.querySelector('input[name="contact[anzahl-farben]"]:checked');
      
      // If no radio is selected, do nothing
      if (!selectedRadio) return;
      
      // Get the selected value
      const selectedValue = selectedRadio.value;
      
      // Determine how many dropdowns to show based on the selected value
      let numDropdownsToShow;
      if (selectedValue === '1-farbig') {
        numDropdownsToShow = 1;
      } else if (selectedValue === '2-farbig') {
        numDropdownsToShow = 2;
      } else if (selectedValue === '3-farbig') {
        numDropdownsToShow = 3;
      } else {
        numDropdownsToShow = 1; // Default to 1 if somehow value is invalid
      }
      
      // Show or hide dropdowns based on the selected value
      colorDropdowns.forEach((dropdown, index) => {
        // Get the name of input fields inside this dropdown
        let inputName;
        if (index === 0) {
          inputName = 'contact[Motivfarbe]';
        } else if (index === 1) {
          inputName = 'contact[Motivfarbe-2]';
        } else if (index === 2) {
          inputName = 'contact[Motivfarbe-3]';
        }
        
        // Get the inputs with this name
        const inputFields = dropdown.querySelectorAll(`input[name="${inputName}"]`);
        
        if (index < numDropdownsToShow) {
          // Show dropdown
          dropdown.style.display = 'block';
          
          // Make inputs required for visible dropdowns
          if (inputFields && inputFields.length > 0) {
            inputFields.forEach(input => {
              input.setAttribute('required', 'required');
            });
          }
        } else {
          // Hide dropdown
          dropdown.style.display = 'none';
          
          // Remove required attribute for hidden dropdowns
          if (inputFields && inputFields.length > 0) {
            inputFields.forEach(input => {
              input.removeAttribute('required');
            });
          }
        }
      });
      
      // Validate current step after updating dropdowns
      if (currentStep === 2) {
        validateCurrentStepFields();
      }
    }
    
    // Add event listener for color radio buttons
    colorRadios.forEach(radio => {
      radio.addEventListener('change', updateColorDropdowns);
    });
    
    // Initialize the dropdowns based on default selection
    updateColorDropdowns();
  }
  
  // Color Picker Function
  function initColorPicker() {
    // Get all color picker sections
    const colorPickers = document.querySelectorAll('.select_item-motivcolor');
    
    // Initialize each color picker separately
    colorPickers.forEach((picker, pickerIndex) => {
      const colorHead = picker.querySelector('.select_item-head');
      const colorDropdown = picker.querySelector('.select_item-dropdown');
      const colorItems = picker.querySelectorAll('.color-picker__item');
      
      // Get the property name based on the picker index
      let propertyName;
      if (pickerIndex === 0) {
        propertyName = 'contact[Motivfarbe]';
      } else if (pickerIndex === 1) {
        propertyName = 'contact[Motivfarbe-2]';
      } else if (pickerIndex === 2) {
        propertyName = 'contact[Motivfarbe-3]';
      }
      
      // Toggle dropdown visibility when clicking on the header
      if (colorHead) {
        colorHead.addEventListener('click', function(e) {
          e.stopPropagation();
          
          // Close all other dropdowns first
          document.querySelectorAll('.select_item-dropdown.active').forEach(dropdown => {
            if (dropdown !== colorDropdown) {
              dropdown.classList.remove('active');
            }
          });
          
          // Toggle this dropdown
          colorDropdown.classList.toggle('active');
        });
      }
      
      // Handle color selection for this picker
      colorItems.forEach(item => {
        const radioInput = item.querySelector('input[type="radio"]');
        const colorLabel = item.querySelector('.color-picker__label');
        
        if (radioInput) {
          item.addEventListener('click', function(e) {
            e.stopPropagation();
            
            // Update all inputs with the same name
            picker.querySelectorAll(`input[name="${propertyName}"]`).forEach(input => {
              input.checked = (input === radioInput);
            });
            
            // Update the header display
            if (colorHead) {
              const headerColorDiv = colorHead.querySelector('.color-picker__color');
              const headerLabel = colorHead.querySelector('.color-picker__label');
              
              if (headerColorDiv) {
                // Remove all existing color classes
                headerColorDiv.className = 'color-picker__color';
                // Add the selected color class
                headerColorDiv.classList.add(`color-picker__color--${radioInput.value}`);
              }
              
              if (headerLabel) {
                headerLabel.textContent = colorLabel.textContent;
              }
            }
            
            // Close dropdown after selection
            colorDropdown.classList.remove('active');
            
            // Validate the step after selection
            if (currentStep === 2) {
              validateCurrentStepFields();
            }
          });
        }
      });
    });
    
    // Close all dropdowns when clicking outside
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.select_item-head') && !event.target.closest('.select_item-dropdown')) {
        document.querySelectorAll('.select_item-dropdown').forEach(dropdown => {
          dropdown.classList.remove('active');
        });
      }
    });
  }
  
  // Function to add validation listeners to relevant form fields
  function addValidationListeners() {
    // Step 0: Upload step
    const uploadcareWidget = uploadcare.Widget('[role=uploadcare-uploader]');
    if (uploadcareWidget) {
      uploadcareWidget.onChange(function() {
        if (currentStep === 0) validateCurrentStepFields();
      });
    }
    
    // Step 1: Folie step
    const folieRadios = document.querySelectorAll('input[name="contact[folie]"]');
    folieRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (currentStep === 1) validateCurrentStepFields();
      });
    });
    
    // Step 2: Farbe step
    const farbeRadios = document.querySelectorAll('input[name="contact[anzahl-farben]"]');
    farbeRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (currentStep === 2) validateCurrentStepFields();
      });
    });
    
    // Step 3: Personal information
    const personalFields = steps[3].querySelectorAll('input[required]');
    personalFields.forEach(field => {
      ['input', 'change', 'blur'].forEach(eventType => {
        field.addEventListener(eventType, function() {
          if (currentStep === 3) validateCurrentStepFields();
        });
      });
    });
    
    // Step 4: Width and message fields
    if (steps[4]) {
      const widthField = steps[4].querySelector('input[name="contact[Breite]"]');
      if (widthField) {
        ['input', 'change', 'blur'].forEach(eventType => {
          widthField.addEventListener(eventType, function() {
            if (currentStep === 4) validateCurrentStepFields();
          });
        });
      }
    }
  }
  
  // --- UPLOADCARE PREVIEW FUNCTIONALITY ---
  // Initialize Uploadcare preview
  initUploadcarePreview();
  
  function initUploadcarePreview() {
    // Get the Uploadcare widget
    const widget = uploadcare.Widget('[role=uploadcare-uploader]');
    
    // When a file is selected
    widget.onChange(function(file) {
      if (file) {
        file.done(function(fileInfo) {
          // Show preview container
          const previewContainer = document.querySelector('.preview-container');
          if (previewContainer) previewContainer.style.display = 'block';
          
          // Set filename
          const fileNameElement = document.getElementById('file-name');
          if (fileNameElement) fileNameElement.textContent = fileInfo.name || 'Unbekannt';
          
          // Format and show file size
          const fileSizeElement = document.getElementById('file-size');
          if (fileSizeElement) {
            const size = formatFileSize(fileInfo.size);
            fileSizeElement.textContent = size;
          }
          
          // Create URL for image preview
          const previewImage = document.getElementById('preview-image');
          if (previewImage) {
            const previewUrl = fileInfo.cdnUrl + '-/preview/';
            previewImage.src = previewUrl;
          }
          
          // Validate the step after file selection
          if (currentStep === 0) {
            validateCurrentStepFields();
          }
        });
      } else {
        // If no file is selected, hide preview
        const previewContainer = document.querySelector('.preview-container');
        if (previewContainer) previewContainer.style.display = 'none';
        
        // Validate the step after file removal
        if (currentStep === 0) {
          validateCurrentStepFields();
        }
      }
    });
  }
  
  // Helper function to format file size
  function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
});